import React from 'react';
import 'antd/dist/antd.css';


class IframePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title:'',url:'',parame:{}
        }
    };
    componentWillMount(){
        if(this.props.objMenu!==null){
            this.setState({title:this.props.objMenu.title});
            this.setState({url:this.props.objMenu.url});
            this.setState({parame:this.props.objMenu.parame});
        }
        
    }
    render() {
        return(
            <div style={{width:'100%',height:'100%'}}>
                <iframe src={this.state.url} frameBorder="0" width="100%" height="100%" scrolling="auto"></iframe>
            </div>
        );
    }
}
export default IframePage;